// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Flex, Typography } from '@iheartjane/reefer';

import type { Feeling } from '@jane/search/types';
import { FEELING_ICONS } from '@jane/search/util';

export interface FeelingCardProps {
  feeling: Feeling;
  selected?: boolean;
  width?: string;
}

const FeelingContainer = styled(Box)<{ flexBasis?: string }>(
  ({ flexBasis }) => ({ flexBasis })
);

export const FeelingCard = ({ feeling, selected, width }: FeelingCardProps) => {
  const Icon = FEELING_ICONS[feeling];

  return (
    <FeelingContainer
      border={selected ? 'purple' : undefined}
      background="grays-ultralight"
      borderRadius="lg"
      p={12}
      minWidth="fit-content"
      flexBasis={width}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center">
        <Icon size="md" />
        <Typography color="grays-black">{feeling}</Typography>
      </Flex>
    </FeelingContainer>
  );
};
